import React from 'react'
import './intro.css'
export default function Intro() {
    return (
        <div className="container-card">
           <p className="intro-title" >
                 QA Engineer | SDET | QA Analyst | Tester | Quality Advocate | QA Advisor
           </p>
            <p className="intro-p" > Results-driven QA Engineer, adept in both manual and automated testing, bringing a quality-first mindset and strong cross-functional collaboration to every project. </p>

                <p className="intro-p" >Proven track record of leading QA efforts from the ground up in fast-paced startups and successfully navigating complex enterprise environments during M&A transitions.</p>
                 <p className="intro-p" > Skilled in building robust automation frameworks using Selenium, Appium, Python, and Java, while also excelling in functional, regression, UAT, and exploratory testing.</p>

                <p className="intro-p" >Holds an MSc in Data Science & Analytics, enhancing the ability to make data-driven QA decisions, conduct root cause analysis, and collaborate effectively with data and engineering teams.</p>
                <p className="intro-p" > Experienced in performance testing with JMeter and API validation using Postman.</p>

                <p className="intro-p" >Passionate about creating scalable QA processes that enable faster, more reliable releases. </p>
                <p className="intro-p" >Focused on implementing shift-left testing, mentoring junior QA team members, and partnering closely with developers and product owners to deliver high-quality software.</p>
                
            <p className="intro-p" >
                Key Skills: Selenium | Python | Java | Appium | Manual Testing | Regression Testing | API Testing | Postman | TestNG | PyTest | JIRA | Agile | CI/CD | UAT | Exploratory Testing | Performance Testing
 
           </p>
            <p className="intro-p" >
                 Interests : Travel, Photography, Blog  
           </p>
            
            <p className="intro-p" >Let’s connect if you’re building quality-first engineering teams or looking for a QA partner to strengthen your release cycles.</p>

        </div>
    )
}
